module.exports = __webpack_public_path__ + "img/shed_assmembly.49928091.jpg";